import { NgIf } from "@angular/common";
import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { KontaktApiService, KontaktVO } from "@core/api/v1";
import { MessageService } from "primeng/api";

@Component({
    selector: 'app-kontakt',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        NgIf,
    ],
    templateUrl: './kontakt.component.html',
    styleUrl: './kontakt.component.scss',
})
export class KontaktComponent {
    kontaktForm = this.formbuilder.group({
        name: ['', [Validators.required, Validators.maxLength(100)]],
        email: ['', [Validators.required, Validators.maxLength(100), Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$")]],
        betreff: ['', [Validators.required, Validators.maxLength(100)]],
        nachricht: ['', [Validators.required, Validators.maxLength(4000)]],
    });
    submitted: boolean = false;

    constructor(private formbuilder: FormBuilder,
                private kontaktApiService: KontaktApiService,
                private messageService: MessageService) {
    }

    senden() {
        this.submitted = true;
        const kontaktVO: KontaktVO = {
            name: this.kontaktForm.get('name')?.value!,
            email: this.kontaktForm.get('email')?.value!,
            betreff: this.kontaktForm.get('betreff')?.value!,
            nachricht: this.kontaktForm.get('nachricht')?.value!,
        }

        if (this.kontaktForm.valid) {
            this.kontaktApiService.sendeAnfrage(kontaktVO).subscribe({
                next: () => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Gesendet',
                        detail: 'Ihre Anfrage wurde erfolgreich entgegen genommen. Vielen Dank!',
                    });
                    this.kontaktForm.reset();
                    this.submitted = false;
                },
                error: () => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Fehler',
                        detail: 'Fehler beim Verarbeiten der Anfrage',
                    });
                }
            });
        } else {
            this.messageService.add({
                severity: 'error',
                summary: 'Fehler',
                detail: 'Fehler beim ausfüllen des Formulars! Bitte überprüfen Sie Ihre Eingaben und versuchen es erneut.',
            });
        }
    }
}
